import gql from 'graphql-tag';

export const ShowArchiveCTAQuery = gql`
	query ShowArchiveCTAQuery($contentId: ID!) {
		content(id: $contentId) {
			nodes {
				id
				operations {
					operation
					targetType
				}
			}
		}
	}
`;
